import { render } from "./DocumentationDocRow.vue?vue&type=template&id=41595246&scoped=true"
import script from "./DocumentationDocRow.vue?vue&type=script&lang=js"
export * from "./DocumentationDocRow.vue?vue&type=script&lang=js"

import "./DocumentationDocRow.vue?vue&type=style&index=0&id=41595246&scoped=true&lang=scss"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41595246"]])

export default __exports__